import type { DiscoveryFilters } from '../../types/discoveryBadges';
import { filtersToSearchParams } from '../../utils/discoveryUrlState';

export const DISCOVER_COLLECTIONS = [
  {
    id: 'featured',
    title: 'Featured Builds',
    description: 'Community favorites, with photos worth a closer look.',
    sort: 'favorite_count',
    mark: '01',
  },
  {
    id: 'recent',
    title: 'Recent Activity',
    description: 'Fresh updates from garages across Bilt:Spec.',
    sort: 'updated_at',
    mark: '02',
  },
  {
    id: 'documented',
    title: 'Most Documented',
    description: 'The fullest build stories, ranked by documentation score.',
    sort: 'documentation_score',
    mark: '03',
  },
  {
    id: 'powerful',
    title: 'Most Powerful Builds',
    description:
      'Highest publicly listed horsepower. Builder-reported; wheel and crank figures may differ.',
    sort: 'horsepower',
    mark: '04',
  },
  {
    id: 'modded',
    title: 'Most Modded',
    description: 'The longest parts lists, ranked by recorded modifications.',
    sort: 'modification_count',
    mark: '05',
  },
] as const;
export type DiscoverCollection = (typeof DISCOVER_COLLECTIONS)[number];
export const findCollection = (id: string | null) => DISCOVER_COLLECTIONS.find((c) => c.id === id);

export function collectionFilters(
  filters: DiscoveryFilters,
  collection: DiscoverCollection,
  preview = true
): DiscoveryFilters {
  return {
    ...filters,
    collection: collection.id,
    sort_by: collection.sort,
    sort_order: 'desc',
    page: preview ? 1 : filters.page,
    limit: preview ? 8 : 20,
  };
}

export function discoveryDestination(
  filters: DiscoveryFilters,
  collection?: DiscoverCollection,
  results = false
): string {
  const params = filtersToSearchParams({ ...filters, page: 1 });
  if (results || collection) params.set('view', 'results');
  else {
    params.delete('sort_by');
    params.delete('sort_order');
  }
  if (collection) params.set('collection', collection.id);
  return `/discover${params.toString() ? `?${params}` : ''}`;
}
